import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/pictures/gamza.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  style: {"color":"#ff8282"},
  class: "text-center font-weight-bold mt-9 mb-4"
}, "HAMWOORI ADMIN", -1)
const _hoisted_2 = {
  key: 0,
  class: "gamza-image",
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = {
  class: "text-white mt-4",
  style: {"color":"#333 !important"}
}

import { ref, watch } from "vue";
import axios from "axios";
import { format } from 'date-fns';
import { LoginForm, Account, LoginResponse } from '../../types/types';
import '@/assets/styles/login.scss';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const store = useStore();
const router = useRouter();
const remember = ref(false);
const loginDialog = ref(false);
const welcomeMessage = ref('');

const form = ref<LoginForm>({
  loginId: "",
  loginPw: "",
});

const account = ref<Account>({
  id: "",
  name: "",
  role: 0,
  role_name: "",
  code: "",
  sisul_name: "",
  emp_num: "",
  status: 0
});

const login = () => {
  const args = {
    loginId: form.value.loginId,
    loginPw: form.value.loginPw,
  };

  axios
    .post("/api/account", args)
    .then(async (res: LoginResponse) => {
      account.value = res.data.member;
      welcomeMessage.value = `${res.data.member.name}님, 환영합니다!`;
      loginDialog.value = true;
      
      await store.dispatch("login", {
        id: res.data.member.id,
        role: res.data.member.role,
        roleName: res.data.member.role_name,
        name: res.data.member.name,
        code: res.data.member.code,
        autoLogin: remember.value,
        sisulName: res.data.member.sisul_name,
        empNum: res.data.member.emp_num,
      });
      
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth());
      store.commit('setAdminYYMM', format(oneMonthAgo, 'yyyy-MM'));
      setTimeout(() => {
        router.push('/AdminIndexPage');
      }, 1500);
    })
    .catch(() => {
      alert("로그인에 실패했습니다. 계정 정보를 확인해주세요.");
    });
};

watch(
  () => [store.state.NonStopId, store.state.NonStopPw],
  ([newId, newPw]) => {
    if (newId) {
      form.value.loginId = newId;
      sessionStorage.removeItem('getNonStopId');
    }
    if (newPw) {
      form.value.loginPw = newPw;
      sessionStorage.removeItem('getNonStopPw');
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "login-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "fill-height",
        align: "center",
        justify: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            xs: "12",
            sm: "10",
            md: "8",
            lg: "6",
            xl: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "login-card",
                elevation: "10"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createVNode(_component_v_form, {
                        onSubmit: _withModifiers(login, ["prevent"]),
                        class: "login-form"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: form.value.loginId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.loginId) = $event)),
                            class: "login-field",
                            "prepend-inner-icon": "mdi-account",
                            variant: "outlined",
                            placeholder: "ID",
                            density: "comfortable",
                            "bg-color": "white",
                            color: "primary",
                            autocomplete: "username",
                            "hide-details": ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: form.value.loginPw,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.loginPw) = $event)),
                            class: "login-field mt-4",
                            "prepend-inner-icon": "mdi-lock",
                            variant: "outlined",
                            placeholder: "PW",
                            type: "password",
                            density: "comfortable",
                            "bg-color": "white",
                            color: "primary",
                            autocomplete: "current-password",
                            "hide-details": ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_checkbox, {
                            modelValue: remember.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((remember).value = $event)),
                            class: "mt-2",
                            color: "primary",
                            "hide-details": "",
                            label: "Remember Me"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_btn, {
                            type: "submit",
                            class: "login-btn mt-4",
                            size: "large",
                            block: "",
                            elevation: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Login ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: loginDialog.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((loginDialog).value = $event)),
        width: "auto"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "pa-4",
            style: {"background":"#ffdef6"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "white",
                    size: "64"
                  }),
                  (account.value.id === 'hamwoori25' && account.value.name === '김아름')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(welcomeMessage.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})